// src/App.js
import React from "react";
import NavBar from "../components/NavBar/NavBar.jsx";
import Footer from "../components/Footer/Footer.jsx";
import SpaceDetailPage from "../components/Profile/EventsAndSpaces/Spaces/SpaceDetailPage.jsx";
import Search from "../components/SearchArea/Search.jsx";

export default function EventDetailsPage() {
  return (
    <div>
      <NavBar />
      <SpaceDetailPage />
      {/* <Search pageType="eventPage" /> */}
    </div>
  );
}
